import { Box } from "@mui/material";
import { Typography } from "@mui/material";
import erasmusFunded from "../assets/footer_image.jpeg";

const Footer = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        backgroundColor: "#333",
        paddingY: 1,
      }}
    >
      <Box
        sx={{
          width: "75%",
          margin: "0 auto",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          gap: "20px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <p
            style={{
              color: "#ccc",
              fontSize: "13px",
              textTransform: "uppercase",
              margin: 0,
              textDecoration: "underline",
            }}
          >
            Disclaimer:
          </p>
          <span
            style={{
              color: "#ccc",
              fontSize: "13px",
              lineHeight: "1.5",
            }}
          >
            (This project is) Funded by the European Union. Views and opinions
            expressed are however those of the author(s) only and do not
            necessarily reflect those of the European Union or the European
            Education and Culture Executive Agency (EACEA). Neither the European
            Union nor EACEA can be held responsible for them.
          </span>
        </Box>
        <img
          src={erasmusFunded}
          alt="erasmus+ Programme"
          style={{ maxWidth: "216px", height: "45px" }}
        />
      </Box>
    </Box>
  );
};

export default Footer;
